import { ComponentProps } from "react"
import * as Tabs from "@radix-ui/react-tabs"
import clsx from "clsx"

export const Tab = (props: ComponentProps<typeof Tabs.Trigger>) => (
	<Tabs.Trigger
		className={clsx(
			"flex-1 border-r border-base-800 px-2.5 py-1.5 text-center text-sm hover:bg-base-600 data-[state=active]:bg-accent-700 data-[state=active]:text-base-950 dark:data-[state=active]:text-base-100",
		)}
		{...props}
	/>
)
